import { Outlet, useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import Header from './Header';
import Footer from './Footer';
import AnnouncementBar from './AnnouncementBar';
import { useRevealReady } from './Motion';
import '../motion.css';

export default function PublicLayout() {
  const { pathname, hash } = useLocation();
  useRevealReady();

  useEffect(() => {
    if (hash) {
      // The target section has to exist in the DOM first — true on first
      // load of the one-page site and after the old /about-etc. routes
      // redirect here, since both land on "/" with the hash already set
      // before this effect runs.
      const id = hash.slice(1);
      requestAnimationFrame(() => {
        document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
      });
    } else {
      window.scrollTo({ top: 0, behavior: 'instant' as ScrollBehavior });
    }
  }, [pathname, hash]);

  return (
    <div className="flex min-h-screen flex-col">
      <AnnouncementBar />
      <Header />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
